import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { StyledPWithADWrap } from './PWithADWrap.style'
import { StyledP } from './ContentParser.style'
import { IPWithAds } from './types'
import { PocTaboolaPageType, PocTaboolaSuffixId, Taboola } from '../Taboola'
import { isDesktop } from '../../client'
import { InArticleBox } from '../Ads'

const midArticleTaboola = (isArticleVod: boolean) => (
  <Taboola
    pageType={
      isArticleVod ? PocTaboolaPageType.article_vod : PocTaboolaPageType.article
    }
    suffixId={PocTaboolaSuffixId.midArticle}
  />
)

export const PWithADWrap = ({
  for_key,
  html,
  cls,
  adId,
  addType = 'dfp',
  isArticleVod,
  mobileOnly,
  pos,
}: IPWithAds) => {
  const [mountAd, setMountAd] = useState(false)
  const router = useRouter()

  useEffect(() => {
    if ((mobileOnly && !isDesktop()) || !mobileOnly) {
      setMountAd(true)
    }
    return () => {
      setMountAd(false)
    }
  }, [adId, mobileOnly])

  return (
    <StyledPWithADWrap key={`${adId}-${for_key}-${router.asPath}`}>
      <StyledP dangerouslySetInnerHTML={{ __html: html }} className={cls} />
      {addType === 'dfp' && mountAd ? (
        <InArticleBox pos={pos} />
      ) : (
        midArticleTaboola(isArticleVod)
      )}
    </StyledPWithADWrap>
  )
}
